module.exports = __webpack_public_path__ + "img/20191227160040360截图20191227110946019.972629f1.jpg";